import { ConstructPost } from '../../types/ConstructPost';
import { AUTH_BASE_PATH } from '../constants/authenticationPath';

export const postLogout = (constructPost: ConstructPost): Promise<unknown> =>
  constructPost(`${AUTH_BASE_PATH}/logout`, undefined, {
    preventDefaultErrorToast: true,
  });
